import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function queryFlowCopyMan(_x) {
  return _queryFlowCopyMan.apply(this, arguments);
}
function _queryFlowCopyMan() {
  _queryFlowCopyMan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/flow/queryFlowCopyMan', METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryFlowCopyMan.apply(this, arguments);
}
export function saveFlowCopyMan(_x2) {
  return _saveFlowCopyMan.apply(this, arguments);
}
function _saveFlowCopyMan() {
  _saveFlowCopyMan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/flow/saveFlowCopyMan', METHOD.POST, data));
      }
    }, _callee2);
  }));
  return _saveFlowCopyMan.apply(this, arguments);
}
export function updateIsRead(_x3) {
  return _updateIsRead.apply(this, arguments);
}
function _updateIsRead() {
  _updateIsRead = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request('/flow/updateIsRead', METHOD.GET, data));
      }
    }, _callee3);
  }));
  return _updateIsRead.apply(this, arguments);
}
export function queryAbnormalApplys(_x4) {
  return _queryAbnormalApplys.apply(this, arguments);
}
function _queryAbnormalApplys() {
  _queryAbnormalApplys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request('/flow/queryAbNormalList', METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _queryAbnormalApplys.apply(this, arguments);
}
export function queryFlowByProcInsId(_x5) {
  return _queryFlowByProcInsId.apply(this, arguments);
}

// 读取xml文件
function _queryFlowByProcInsId() {
  _queryFlowByProcInsId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request('/flowable/instance/queryFlowByProcInsId', METHOD.GET, {
            procInsId: data
          }));
      }
    }, _callee5);
  }));
  return _queryFlowByProcInsId.apply(this, arguments);
}
export function readXml(data) {
  return request('/flowable/definition/readXml', METHOD.GET, {
    processDefinitionId: data
  });
}
export default {
  queryFlowCopyMan: queryFlowCopyMan,
  saveFlowCopyMan: saveFlowCopyMan,
  updateIsRead: updateIsRead,
  queryAbnormalApplys: queryAbnormalApplys
};